import { RestoreIcon } from './RestoreIcon';

/**
 * author: Google
 * id FF1CAAB4-2192-442F-88F1-08DEB67E21F0
 * name restore
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/restore.svg
 * tags
 * - Arrow 
 */
export const RotateCounterClockwiseIcon = RestoreIcon;
export default RotateCounterClockwiseIcon